export default {
  animationEasing: 'quarticInOut',
  grid: {
    left: '8%',
    right: '12%',
    top: '15%',
    bottom: '10%',
    containLabel: false
  },
  xAxis: {
    name: '日期',
    nameTextStyle: {
      color: '#7A8399'
    },
    nameGap: 5,
    type: 'category',
    data: [],
    axisTick: {
      show: false
    },
    axisLabel: {
      color: '#7A8399',
      fontSize: 12
    },
    axisLine: {
      lineStyle: {
        color: '#EDEFF3'
      }
    }
  },
  yAxis: [{
    name: '推荐数量',
    nameTextStyle: {
      color: '#262D40'
    },
    type: 'value',
    data: [],
    splitLine: {
      show: false
    },
    axisLabel: {
      color: '#7A8399',
      fontSize: 12
    },
    axisTick: {
      inside: true,
      show: true,
      lineStyle: {
        color: '#F0EFF4'
      }
    },
    axisLine: {
      lineStyle: {
        color: '#EDEFF3'
      }
    }
  }],
  series: [{
      name: '卖出',
      type: 'bar',
      barWidth: 21,
      stack: '推荐',
      label: {
        color: '#EDEFF3',
        position: 'inside',
        show: true
      },
      itemStyle: {
        color: '#1BAA3C'
      },
      data: []
    },{
      name: '业绩不佳',
      type: 'bar',
      barWidth: 21,
      stack: '推荐',
      label: {
        color: '#EDEFF3',
        position: 'inside',
        show: true
      },
      itemStyle: {
        color: '#3BDD00'
      },
      data: []
    },{
      name: '持有',
      type: 'bar',
      barWidth: 21,
      stack: '推荐',
      label: {
        color: '#EDEFF3',
        position: 'inside',
        show: true
      },
      itemStyle: {
        color: '#FFA700'
      },
      data: []
    },{
      name: '买入',
      type: 'bar',
      barWidth: 21,
      stack: '推荐',
      label: {
        color: '#EDEFF3',
        position: 'inside',
        show: true
      },
      itemStyle: {
        color: '#FF4200'
      },
      data: []
    },{
      name: '强力买入',
      type: 'bar',
      barWidth: 21,
      stack: '推荐',
      label: {
        color: '#EDEFF3',
        position: 'inside',
        show: true
      },
      itemStyle: {
        color: '#E63535'
      },
      data: []
    },{
      name: '总值',
      type: 'line',
      symbolOffset: [0, '-50%'],
      label: {
        color: '#262D40',
        position: 'top',
        show: true
      },
      lineStyle: {
        opacity: 0
      },
      itemStyle: {
        color: 'transparent'
      },
      data: []
    }
  ]
}